
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["ICON_VIDEO",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"class":"ICON_VIDEO","version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 81 57.5","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M77.9 0H3.1C1.4 0 0 1.3 0 3v51.5c0 1.7 1.4 3 3.1 3H78c1.7 0 3.1-1.3 3.1-3V3c-.1-1.7-1.5-3-3.2-3zM2.1 15.4h14.4l.1.2.2-.2h62v39.1c0 .5-.4 1-1 .9H3.1c-.5 0-.9-.4-1-.9V15.4zm0-2.1V3c0-.5.4-.9 1-.9h3l8.8 11.3H2.1zm15.5 0L8.8 2.1h11.7l8.8 11.3H17.6zm14.3 0L23.1 2.1h11.8l8.8 11.3H31.9zm14.5 0L37.5 2.1h11.8l8.8 11.3H46.4zm14.4 0L52 2.1h11.8l8.8 11.3H60.8zm18.1 0h-3.6L66.4 2.1h11.5c.5 0 .9.4 1 .9v10.3z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M25.7 39c0 .1.1.1.2.1h.1c.1 0 .2-.1.2-.1l3.8-8.1c.1-.2 0-.3-.2-.3h-1.6c-.1 0-.2.1-.2.1l-2 4.4h-.1l-2-4.4c0-.1-.1-.1-.2-.1h-1.6c-.2 0-.3.2-.2.3l3.8 8.1zM31.2 39h1.4c.1 0 .2-.1.2-.2v-7.9c0-.1-.1-.2-.2-.2h-1.4c-.1 0-.2.1-.2.2v7.9c0 .1.1.2.2.2zM35.2 39h2.9c2.3 0 4.2-1.9 4.2-4.2 0-2.3-1.9-4.2-4.2-4.2h-2.9c-.1 0-.2.1-.2.2v7.9c-.1.2 0 .3.2.3zm1.6-6.7H38c1.4 0 2.3 1.1 2.3 2.4 0 1.4-1 2.4-2.3 2.4h-1.2v-4.8zM44 39h5c.1 0 .2-.1.2-.2v-1.3c0-.1-.1-.2-.2-.2h-3.3v-1.6h2.7c.1 0 .2-.1.2-.2v-1.3c0-.1-.1-.2-.2-.2h-2.7v-1.5H49c.1 0 .2-.1.2-.2V31c0-.1-.1-.2-.2-.2h-5c-.1 0-.2.1-.2.2v7.9s.1.1.2.1zM54.5 39.1c2.4 0 4.3-1.9 4.3-4.3s-1.9-4.3-4.3-4.3-4.3 1.9-4.3 4.3 1.9 4.3 4.3 4.3zm0-6.7c1.3 0 2.4 1.1 2.4 2.4 0 1.3-1.1 2.4-2.4 2.4-1.3 0-2.4-1.1-2.4-2.4 0-1.3 1.1-2.4 2.4-2.4z"}})])
          )
        }
      }
    